import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " (Hover to show) ", -1)
const _hoisted_3 = { class: "clipboard-credentials__copy" }
const _hoisted_4 = {
  class: "animate__animated animate__fadeIn",
  ref: "copy"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "clipboard-credentials",
    onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showValue = false))
  }, [
    (!_ctx.hidden || _ctx.showValue)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          class: "animate__animated animate__fadeIn",
          type: "text",
          value: (!_ctx.hidden || _ctx.showValue) ? _ctx.value : '',
          disabled: "",
          readonly: ""
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "clipboard-credentials__hidden animate__animated animate__fadeIn",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showValue = true))
        }, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          _hoisted_2
        ], 32)),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("button", _hoisted_4, " Copy ", 512), [
        [_vShow, _ctx.status === _ctx.CB_STATUS.default]
      ]),
      _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.status), {
        class: _normalizeClass(["animate__animated animate__fadeIn", _ctx.status])
      }, null, 8, ["class"])), [
        [_vShow, _ctx.status !== _ctx.CB_STATUS.default]
      ])
    ])
  ], 32))
}